//Event listener to wait for scripts to load before running SF code
function getCookie(name) {
    let cookies = document.cookie.split(";"),
        toReturn;

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(name + "=") === 0) {
            toReturn = cookie.substring((name + "=").length, cookie.length);
        }
    }
    return toReturn;
}

window.addEventListener("load", (event) => {                
    if(location.hostname === "summitpccstage.wpengine.com" || location.hostname === "summit.pointclickcare.com") {
        const utmCookie = (getCookie("__utmzz"));
        const utmSplit = utmCookie.split("|");
        const utmSource = encodeURIComponent(utmSplit[0].split("=")[1]);
        const utmMedium = encodeURIComponent(utmSplit[1].split("=")[1]);
        const utmCampaign = encodeURIComponent(utmSplit[2].split("=")[1]);                        
        const links = document.getElementsByTagName('a');

        for(var i = 0; i< links.length; i++){            
            if(links[i].href === "https://events.pointclickcare.com/GlN151?RefId=SUMMIT2025"){                

                if(utmMedium != "(not%20set)") {
                    links[i].href = links[i].href + "&utm_medium=" + utmMedium
                }

                if(utmSource != "(not%20set)") {
                    links[i].href = links[i].href + "&utm_source=" + utmSource
                }

                if(utmCampaign != "(not%20set)") {
                    links[i].href = links[i].href + "&utm_campaign=" + utmCampaign
                }                
            }
        }
    }
});